"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wheel = void 0;
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importStar(require("react"));
const renderer_1 = require("api/renderer");
const fortunes_1 = __importDefault(require("store/fortunes"));
function Wheel({ onToggleSettings }) {
    const canvas = react_1.useRef();
    let renderer;
    let offX = 0;
    let offY = 0;
    const onMouseDown = react_1.useCallback((ev) => {
        if (ev.getModifierState("Shift") || canvas.current == null) {
            return;
        }
        offX = ev.clientX;
        offY = ev.clientY;
    }, []);
    const onMouseUp = react_1.useCallback((ev) => {
        if (ev.getModifierState("Shift") || canvas.current == null) {
            return;
        }
        const strength = Math.max(0.5, ((Math.abs(offX - ev.clientX) + Math.abs(offY - ev.clientY)) * 2) / fortunes_1.default.size);
        renderer === null || renderer === void 0 ? void 0 : renderer.startRoll(strength);
    }, []);
    const onWheelClick = react_1.useCallback((ev) => {
        if (ev.getModifierState("Shift")) {
            onToggleSettings();
        }
    }, []);
    react_1.useEffect(() => {
        if (canvas.current == null) {
            return;
        }
        const ctx = canvas.current.getContext("2d");
        mobx_1.runInAction(() => {
            renderer = new renderer_1.WheelCanvas(ctx);
        });
        return mobx_1.autorun(() => {
            const newOpts = {
                height: fortunes_1.default.size,
                width: fortunes_1.default.size,
                items: fortunes_1.default.items,
                colors: fortunes_1.default.itemColors,
                baseRotationTime: fortunes_1.default.baseRotationTime,
                baseRotationSpeed: (fortunes_1.default.baseRotationSpeed / 1000) * fortunes_1.default.baseRotationTime,
                font: fortunes_1.default.font,
                textOffset: fortunes_1.default.textOffset,
                durationFactor: fortunes_1.default.durationFactor,
                speedFactor: fortunes_1.default.speedFactor,
                stopFactor: fortunes_1.default.stopFactor,
                clickSound: fortunes_1.default.clickSoundUrl,
                winSound: fortunes_1.default.winSoundUrl,
                minSpeed: fortunes_1.default.minSpeed,
                forceStopChance: fortunes_1.default.forceStopChance,
                highlightDurationTotal: fortunes_1.default.highlightDurationTotal,
                highlightIntervals: fortunes_1.default.highlightIntervals,
                lampsIntervals: fortunes_1.default.lampsIntervals,
                lampsAmount: fortunes_1.default.lampsAmount,
                angle: fortunes_1.default.angle,
                onAngleChanged: fortunes_1.default.setAngle,
            };
            setTimeout(() => {
                renderer.updateOptions(newOpts);
            }, 5);
            fortunes_1.default.save();
        });
    }, [canvas]);
    return react_1.default.createElement(mobx_react_1.Observer, null, () => react_1.default.createElement("div", { style: { minWidth: fortunes_1.default.size }, className: "wheel" },
        react_1.default.createElement("canvas", { width: fortunes_1.default.size, height: fortunes_1.default.size, ref: canvas, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onClick: onWheelClick, style: { cursor: "pointer", width: fortunes_1.default.size, height: fortunes_1.default.size } })));
}
exports.Wheel = Wheel;
